<!-- Template for Default card type -->
<ng-template #defaultCardStyle>
	<!-- FUNDRAISER CARD TAKES [fundraiserCardData] AS AN INPUT -->

	<mat-card
		id="fundraiserCardcomp"
		#fundraiserCard
		class="mat-elevation-z1"
		[ngClass]="this.isClickAllowed ? 'card-clickable' : ''"
		(click)="this.isClickAllowed ? this.routeToFundraiserEdit() : null"
	>
		<!-- FUNDRAISER'S BACKGROUND VIDEO -->

		<img
			i18n="@@fundraiserCard_createBackgroundImage"
			mat-card-image
			*ngIf="this.fundraiserCardData?.backgroundImage?.video as videoURL"
			src="{{ this.youtubeThumbnail }}"
			loading="lazy"
			onerror="this.src='./assets/img/fundraiser_default_bg.png';this.onerror='';"
			alt="{{ fundraiser_bg_img.alt }}"
		/>

		<!-- FUNDRAISER'S BACKGROUND IMAGE -->
		<img
			id="{{ slug }}"
			i18n="@@fundraiserCard_createBackgroundImage"
			mat-card-image
			*ngIf="!this.fundraiserCardData?.backgroundImage?.video"
			src="{{ fundraiser_bg_img.src }}"
			loading="lazy"
			(error)="handleImageError($event, defaultBackgroundImage)"
			alt="{{ fundraiser_bg_img.alt }}"
		/>

		<!-- MAT CARD HEADER -->
		<mat-card-header>
			<img
				i18n="@@fundraiserCard_createuserImage"
				mat-card-avatar
				src="{{ profile_avatar_img.src }}"
				loading="lazy"
				(error)="handleImageError($event, defaultProfileImage)"
				alt="{{ profile_avatar_img.alt }}"
			/>
			<mat-card-title>{{
				fundraiser_title
			}}</mat-card-title>
			<mat-card-subtitle>{{ profile_name }}</mat-card-subtitle>
		</mat-card-header>

		<!-- MAT CONTENT -->
		<mat-card-content>
			<p>{{ fundraiser_description }}</p>

			<!-- SHOW DONATION RECEIVED AND TARGET AMOUNT -->
			<mat-label
				*ngIf="isShowBothDonationAndTargetAmount"
				class="mat-subtitle-1"
			>
				<b
					>{{ currency }}&nbsp;
					{{ donation_received_amount + offlineDonationAmount | number }}</b
				>&nbsp;
				<span
					i18n="@@fundraiserCard_donationTargetedAmount"
					class="light-grey-texts"
					>of </span
				>&nbsp;
				<span class="light-grey-texts"
					>{{ currency }}&nbsp;{{ donation_target_amount | number }}</span
				>
			</mat-label>
			<!-- SHOW ONLY DONATION RECEIVED -->
			<mat-label *ngIf="isShowOnlyDonationAmountView" class="mat-subtitle-1">
				<b
					>{{ currency }} &nbsp;{{
						donation_received_amount + offlineDonationAmount | number
					}}</b
				>&nbsp;
				<span i18n="@@fundraiserCard_donationReceived_label"
					>Donation received</span
				>
			</mat-label>
			<!-- SHOW ONLY TARGET AMOUNT -->
			<mat-label *ngIf="isShowOnlyTargetAmountView" class="mat-subtitle-1">
				<b>{{ currency }}&nbsp;{{ donation_target_amount | number }} </b>&nbsp;
				<span i18n="@@fundraiserCard_targetAmount_label">Targeted amount</span>
			</mat-label>
			<mat-label
				class="mat-subtitle-1"
				*ngIf="
					!(
						isShowBothDonationAndTargetAmount ||
						isShowOnlyDonationAmountView ||
						isShowOnlyTargetAmountView
					)
				"
			>
				&nbsp;
			</mat-label>

			<!-- MAT PROGRESS BAR -->
			<div *ngIf="fundraiserCardData?.showDonationAmount">
				<mat-progress-bar
					class="m-t-xs m-b-xs"
					value="{{ donation_progress_percentage }}"
				></mat-progress-bar>
			</div>

			<!-- DONATION PROGRESS PERCENTAGE AND DONATION DAYS LEFT -->
			<!-- TODO: uncomment below p tag to add margin -->
			<!-- <p></p> -->
			<div fxLayout="row" fxLayoutAlign="space-between start">
				<p>
					<span *ngIf="donation_days_left > 1">
						{{ donation_days_left }}&nbsp;
						<span i18n="@@fundraiserCard_donationDaysLeft_label"
							>day(s) left</span
						>
					</span>
					<span *ngIf="donation_days_left === 1">
						<span i18n="@@fundraiserCard_lastDays_label">Last day</span>
					</span>
					<span *ngIf="donation_days_left === 0">
						<span i18n="@@myFundraisers_closed_mat_tab">Closed</span>
					</span>
				</p>
				<p>
					<!--* INFO: to calculate percentage both, Donation received amount and target amount are required-->
					<span *ngIf="isShowBothDonationAndTargetAmount">
						<!-- {{donation_progress_percentage | number: '1.0-1'}}% -->
						{{
							(100 * donation_received_amount) / donation_target_amount
								| number : '1.0-1'
						}}%
					</span>
				</p>
				<!--* INFO if donation_target_amount or donation_days_left is empty then add p tag to show consistent spacing in bottom -->
				<p *ngIf="!(isShowBothDonationAndTargetAmount || isDaysLeftShow)">
					&nbsp;
				</p>
			</div>
		</mat-card-content>
	</mat-card>
</ng-template>

<!-- Template for small card type -->
<ng-template
	[ngIf]="type === 'small' || type === 'donationPage'"
	[ngIfElse]="defaultCardStyle"
>
	<ng-container
		*ngIf="type === 'small' && _media.isActive('xs')"
		[ngTemplateOutlet]="smallCard_vertical"
	></ng-container>

	<ng-container
		*ngIf="type === 'small' && _media.isActive('gt-xs')"
		[ngTemplateOutlet]="smallCard_horizontal"
	></ng-container>

	<ng-container
		*ngIf="type === 'donationPage'"
		[ngTemplateOutlet]="donationPageCard"
	></ng-container>
</ng-template>

<!-- Template for small card type -->
<ng-template #smallCard_horizontal>
	<mat-card
		class="mat-elevation-z2 card-clickable m-s"
		(click)="routeToFundraiserEdit()"
	>
		<mat-card-content fxLayout="row">
			<div fxLayout="column" fxLayoutAlign="center">
				<ng-container>
					<img
						*ngIf="this.fundraiserCardData?.backgroundImage?.video as videoURL"
						[ngStyle]="{ cover: 'fill' }"
						height="120"
						width="240"
						src="{{ this.youtubeThumbnail }}"
						loading="lazy"
						onerror="this.src='./assets/img/fundraiser_default_bg.png';this.onerror='';"
						alt="{{ fundraiser_bg_img.alt }}"
					/>

					<img
						*ngIf="!this.fundraiserCardData?.backgroundImage?.video"
						[ngStyle]="{ cover: 'fill' }"
						height="120"
						width="240"
						src="{{ fundraiser_bg_img.src }}"
						loading="lazy"
						(error)="handleImageError($event, defaultBackgroundImage)"
						alt="{{ fundraiser_bg_img.alt }}"
						class="fundraiser-small-image"
					/>
				</ng-container>
			</div>
			<div
				fxLayout="column"
				class="m-l-m"
				fxFlex="100%"
				fxFlex.sm="100%"
				fxFlex.xs="100"
			>
				<!-- CARD HEADER -->
				<div class="header">
					<div fxLfayout="row" fxLayoutAlign="space-between" fxLayoutGap="1%">
						<div class="mat-subtitle-2 title">
							{{ truncateText(fundraiser_title, 55) }}
						</div>
						<button mat-icon-button>
							<span class="material-icons-outlined"> edit </span>
						</button>
					</div>
					<ng-container *ngIf="fundraiserCardData?.isChild">
						<div class="mat-caption">
							<span i18n="@@fundraiser_card_connectedTo_label"
								>Connected to</span
							>&nbsp;
							{{ truncateText(parent_fundraiser_title, 16) }}
						</div>
					</ng-container>
				</div>
				<div>
					<!-- MAT CARD HEADER -->
					<div fxLayout="row" fxLayoutGap="2%">
						<img
							style="width: 20px; height: 20px !important"
							i18n="@@fundraiserCard_createuserImage"
							mat-card-avatar
							src="{{ profile_avatar_img.src }}"
							loading="lazy"
							(error)="handleImageError($event, defaultProfileImage)"
							alt="{{ profile_avatar_img.alt }}"
						/>
						<p>{{ truncateText(profile_name, 26) }}</p>
					</div>
					<div fxLayout="row" fxLayoutAlign="space-between flex-end">
						<!-- SHOW DONATION RECEIVED AND TARGET AMOUNT -->
						<div>
							<mat-label
								*ngIf="!isShowOnlyDonationAmountView"
								class="mat-subtitle-1"
							>
								<div
									*ngIf="donation_received_amount.toString().length > 2"
									class="hover-class"
									matTooltip="{{ hoverTooltip }}"
								>
									<b
										>{{ currency }}&nbsp;{{
											donation_received_amount | number
										}}</b
									>&nbsp;
									<span i18n="@@fundraiserCard_donationTargetAmount">of </span
									>&nbsp;{{ currency }}&nbsp;{{
										trimDonationTarget(donation_target_amount)
									}}
								</div>
								<div *ngIf="donation_received_amount.toString().length < 3">
									<b
										>{{ currency }}&nbsp;{{
											donation_received_amount | number
										}}</b
									>&nbsp;
									<span i18n="@@fundraiserCard_donationTargetAmount">of </span
									>&nbsp;{{ currency }}&nbsp;{{
										donation_target_amount | number
									}}
								</div>
							</mat-label>
							<!-- SHOW ONLY DONATION RECEIVED -->
							<mat-label
								*ngIf="isShowOnlyDonationAmountView"
								class="mat-subtitle-1"
							>
								<b
									>{{ currency }}&nbsp;
									{{ donation_received_amount | number }}</b
								>
							</mat-label>
						</div>

						<div>
							<ng-container *ngIf="!fundraiserCardData?.isChild">
								<div
									class="hover-class"
									matTooltip="{{ mainFundraiserToolTip }}"
								>
									<img
										width="20"
										height="20"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/mainFundraiser/public"
									/>
								</div>
							</ng-container>
							<ng-container *ngIf="fundraiserCardData?.isChild">
								<div
									class="hover-class"
									matTooltip="{{ connectedFundraiserToolTip }}"
								>
									<img
										width="20"
										height="20"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/connectedFundraiser/public"
									/>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
			<!-- <div fxLayout="row">
		</div> -->
		</mat-card-content>
	</mat-card>
</ng-template>
<ng-template #smallCard_vertical>
	<mat-card
		class="card-clickable m-b-m"
		(click)="routeToFundraiserEdit()"
		[ngStyle]="{ width: '90%' }"
	>
		<mat-card-content>
			<div fxLayout="column">
				<ng-container>
					<img
						*ngIf="this.fundraiserCardData?.backgroundImage?.video as videoURL"
						class="w-100"
						src="{{ this.youtubeThumbnail }}"
						loading="lazy"
						(error)="handleImageError($event, defaultBackgroundImage)"
					/>
					<img
						*ngIf="!this.fundraiserCardData?.backgroundImage?.video"
						class="fundraiser-vertical-small-image"
						src="{{ fundraiser_bg_img.src }}"
						loading="lazy"
						(error)="handleImageError($event, defaultBackgroundImage)"
					/>
				</ng-container>
				<div fxLayout="row">
					<div fxFlex>
						<!-- <span class="mat-subtitle-2"> {{ fundraiser_title }} </span> -->
						<div
							fxLfayout="row"
							fxLayoutAlign="space-between"
							fxLayoutGap="1%"
							ngClass="p-t-xs"
						>
							<div class="mat-subtitle-2 title">
								{{ truncateText(fundraiser_title, 63) }}
							</div>
							<span class="material-icons-outlined"> edit </span>
						</div>
						<br />
						<ng-container *ngIf="fundraiserCardData?.isChild">
							<span class="mat-caption">
								<span>Connected to</span>&nbsp;
								{{ profile_name }}
							</span>
							<br />
						</ng-container>

						<div fxLayout="row" fxLayoutAlign="space-between">
							<!-- SHOW DONATION RECEIVED AND TARGET AMOUNT -->
							<div>
								<mat-label
									*ngIf="!isShowOnlyDonationAmountView"
									class="mat-subtitle-1"
								>
									<b>
										{{ currency }}&nbsp;{{
											donation_received_amount | number
										}}</b
									>&nbsp;
									<span i18n="@@fundraiserCard_donationTargetedAmount">of </span
									>&nbsp; {{ currency }}&nbsp;{{
										donation_target_amount | number
									}}
								</mat-label>
								<!-- SHOW ONLY DONATION RECEIVED -->
								<mat-label
									*ngIf="isShowOnlyDonationAmountView"
									class="mat-subtitle-1"
								>
									<b>
										{{ currency }}&nbsp;{{
											donation_received_amount | number
										}}</b
									>&nbsp;
									<span i18n="@@fundraiserCard_donationReceived_title"
										>Donation received</span
									>
								</mat-label>
							</div>
							<div>
								<ng-container *ngIf="!fundraiserCardData?.isChild">
									<img
										width="20"
										height="20"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/mainFundraiser/public"
									/>
								</ng-container>
								<ng-container *ngIf="fundraiserCardData?.isChild">
									<img
										width="20"
										height="20"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/connectedFundraiser/public"
									/>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</ng-template>

<ng-template #donationPageCard>
	<div fxLayout="row" fxLayout.xs="column">
		<div fxLayout="column" fxLayoutAlign="center">
			<ng-container>
				<img
					*ngIf="this.fundraiserCardData?.backgroundImage?.video as videoURL"
					[ngClass]="{ 'w-100 h-100': isSmallScreen() }"
					height="120"
					width="240"
					src="{{ this.youtubeThumbnail }}"
					loading="lazy"
					onerror="this.src='./assets/img/fundraiser_default_bg.png';this.onerror='';"
					alt="{{ fundraiser_bg_img.alt }}"
				/>

				<img
					*ngIf="!this.fundraiserCardData?.backgroundImage?.video"
					[ngClass]="{ 'w-100 h-100': isSmallScreen() }"
					height="120"
					width="240"
					src="{{ fundraiser_bg_img.src }}"
					loading="lazy"
					(error)="handleImageError($event, defaultBackgroundImage)"
					alt="{{ fundraiser_bg_img.alt }}"
					class="fundraiser-small-image"
				/>
			</ng-container>
		</div>
		<div
			fxLayout="column"
			ngClass.gt-xs="p-l-m"
			ngClass.lt-sm="p-t-xs"
			fxFlex="100%"
		>
			<!-- CARD HEADER -->
			<div class="header" ngClass="p-t-xs">
				<div fxLfayout="row" fxLayoutAlign="space-between">
					<div class="mat-headline-6">
						{{ truncateText(fundraiser_title, 45) }}
					</div>
				</div>
			</div>
			<div>
				<div fxLayout="row" fxLayoutAlign="space-between flex-end">
					<!-- SHOW DONATION RECEIVED AND TARGET AMOUNT -->
					<div>
						<mat-label
							*ngIf="isShowBothDonationAndTargetAmount"
							class="mat-headline-6"
						>
							<div
								*ngIf="donation_received_amount.toString().length > 2"
								class="hover-class"
								matTooltip="{{ hoverTooltip }}"
							>
								<b class="mat-headline-6"
									>{{ currency }}&nbsp;{{
										donation_received_amount | number
									}}</b
								>&nbsp;
								<span
									i18n="@@fundraiserCard_donationTargetAmount"
									class="mat-headline-6 light-grey-texts"
									>of </span
								>&nbsp;<span class="mat-headline-6 light-grey-texts"
									>{{ currency }}&nbsp;{{ donation_target_amount }}</span
								>
							</div>
							<div *ngIf="donation_received_amount.toString().length < 3">
								<b class="mat-headline-6"
									>{{ currency }}&nbsp;{{
										donation_received_amount | number
									}}</b
								>&nbsp;
								<span
									i18n="@@fundraiserCard_donationTargetAmount"
									class="mat-headline-6 light-grey-texts"
									>of </span
								>&nbsp;
								<span class="mat-headline-6 light-grey-texts"
									>{{ currency }}&nbsp;{{
										donation_target_amount | number
									}}</span
								>
							</div>
						</mat-label>
						<!-- SHOW ONLY DONATION RECEIVED -->
						<mat-label
							*ngIf="isShowOnlyDonationAmountView"
							class="mat-headline-6"
						>
							<b
								>{{ currency }}&nbsp; {{ donation_received_amount | number }}</b
							>
						</mat-label>
						<mat-label
							*ngIf="isShowOnlyTargetAmountView"
							class="mmat-headline-6"
						>
							<b>{{ currency }}&nbsp;{{ donation_target_amount | number }} </b
							>&nbsp;
							<span i18n="@@fundraiserCard_targetAmount_label"
								>Targeted amount</span
							>
						</mat-label>
						<mat-label
							class="mat-headline-6"
							*ngIf="
								!(
									isShowBothDonationAndTargetAmount ||
									isShowOnlyDonationAmountView ||
									isShowOnlyTargetAmountView
								)
							"
						>
							&nbsp;
						</mat-label>
					</div>
				</div>
				<div
					fxLayout="row"
					fxLayoutGap="2%"
					*ngIf="fundraiserCardData?.showDonationAmount"
					ngClass="p-t-s p-b-s"
				>
					<mat-progress-bar
						value="{{ donation_progress_percentage }}"
					></mat-progress-bar>
				</div>
			</div>
		</div>
		<!-- <div fxLayout="row">
		</div> -->
	</div>
</ng-template>
